<ui-filter-container>
    <ui-text-filter
        search-filter
        [filter]="searchFilter"
        [placeholder]="'Suchbegriff eingeben'"
    />

    <ui-multi-select-filter
        [filter]="typesFilter"
        [options]="(typesOptions$ | async) ?? filterOptionsFallback"
        [placeholder]="(typesFilterPlaceholder$ | async) ?? ''"
        (reloadFilterOptions)="reloadFilterOptions()"
    />

    <ui-multi-select-filter
        [filter]="educationalBranchesFilter"
        [options]="(educationalBranchesOptions$ | async) ?? filterOptionsFallback"
        [placeholder]="(educationalBranchesFilterPlaceholder$ | async) ?? ''"
        [limitingConfig]="(educationalBranchesLimitingConfig$ | async) ?? undefined"
        (reloadFilterOptions)="reloadFilterOptions()"
    />

    <ui-dropdown-filter
        [filter]="careServicesFilter"
        [options]="(careServicesOptions$ | async) ?? filterOptionsFallback"
        [placeholder]="(careServicesFilterPlaceholder$ | async) ?? ''"
        [limitingConfig]="(careServicesLimitingConfig$ | async) ?? undefined"
        (reloadFilterOptions)="reloadFilterOptions()"
    />

    <ui-dropdown-filter
        [filter]="studentGuidesFilter"
        [options]="studentGuidesOptions"
        (reloadFilterOptions)="reloadFilterOptions()"
    />

    <ui-filter-content-block
        [fullWidth]="true"
        [title]="'Augsburg baut auf Bildung'"
    >
        <span class="info-text">
            Wo wird saniert? Wo ist es geplant? Was ist bereits abgeschlossen? Filtern Sie die aktuellen Maßnahmen von „Augsburg baut auf Bildung“
        </span>
    </ui-filter-content-block>

    <ui-multi-select-filter
        [filter]="measureTypesFilter"
        [options]="(measureTypesOptions$ | async) ?? filterOptionsFallback"
        [placeholder]="(measureTypesFilterPlaceholder$ | async) ?? ''"
        (reloadFilterOptions)="reloadFilterOptions()"
    />

    <ui-multi-select-filter
        [filter]="measureStatusFilter"
        [options]="measureStatusOptions"
        [placeholder]="measureStatusFilterPlaceholder"
        (reloadFilterOptions)="reloadFilterOptions()"
    />
</ui-filter-container>
